
import * as DataUtil from "Flow2/components/CustomCollections/CustomDataUtil/CustomDataUtil";
import CustomTypes from "Flow2/components/CustomCollections/CustomDataConfig/CustomDataTypes";
import * as CustomConfig from "Flow2/components/CustomCollections/CustomDataConfig/CustomDataConfig";
import { isNLW } from 'Flow2/components/CustomCollections/CustomDataControllers/CustomAppController';

const getGrantingForApp = ({ user, field, grantingField }) => {
    if (field === CustomTypes.STATUS && isNLW()) {
        if (grantingField === "awaiting_approval") {
            if (user && user.role && (user.role === CustomTypes.ROLE_LEVEL5 || user.role === CustomTypes.ROLE_LEVEL6
                || user.role === CustomTypes.ROLE_LEVEL7 || user.role === CustomTypes.ROLE_LEVEL8))
                return true;
            else
                return false;
        }
        return true;
    }
    return true;
}

export default getGrantingForApp;

export const initGranting = (userrole, language) => {
    let lg = DataUtil.getLanguage(language);
    let grantingObj = null;
    if (userrole === CustomTypes.ROLE_LEVEL3) {
        let name = CustomTypes.STATUS;
        let data = CustomConfig.customstatus.data;
        if (DataUtil.isDataArray(data)) data.map(item => {
            if (DataUtil.getId(item) === CustomTypes.GRANTING_VALUE_STATUS) {
                grantingObj = { [name]: DataUtil.getId(item), [`${name}_tmp`]: item[lg] };
            }
        })
    }
    return grantingObj;
}


export const checkGranting = (field, userrole) => {
    if (field === CustomTypes.STATUS && (userrole && (userrole === CustomTypes.ROLE_LEVEL0
        || userrole === CustomTypes.ROLE_LEVEL1 || userrole === CustomTypes.ROLE_LEVEL2/*|| userrole === CustomConfig.ROLE_LEVEL3*/)))
        return false;

    return true;
}